import { ICellRenderer } from 'ag-grid-community';
import { fortmatCurrency } from 'src/utils/utils';

export default class CurrencyRenderer implements ICellRenderer {
  private eGui: HTMLElement;

  public init(params: any): void {
    this.eGui = document.createElement('div');
    const formattedCurrency = fortmatCurrency(params?.value, params?.currency, params?.locales, params?.minimumFractionDigits, params?.maximumFractionDigits);
    this.eGui.innerHTML = formattedCurrency;
  }

  public getGui(): HTMLElement {
    return this.eGui;
  }

  public refresh(): boolean {
    return true;
  }
}
